<template>
  <section class="relative isolate w-full overflow-hidden bg-black">
    <div class="absolute inset-0 h-full w-full opacity-20">
      <BrandTopography />
    </div>

    <div
      class="absolute inset-0 z-[2] bg-gradient-to-b from-transparent via-transparent to-neutral-950"
    />

    <div
      class="relative z-[3] mx-auto mt-12 mb-8 grid max-w-[var(--breakpoint-2xl)] grid-cols-1 items-center justify-center gap-8 overflow-visible px-6 py-0 pb-6 sm:px-8 md:gap-10 lg:grid-cols-5"
    >
      <!-- Copy -->
      <div class="col-span-1 max-w-prose lg:col-span-3">
        <div class="text-base font-bold text-yellow-400 uppercase">
          {{ type }}
        </div>
        <h1 class="mt-0.5 text-3xl font-extrabold text-white sm:text-5xl">
          <span v-if="type !== 'Booking Confirmation'">
            {{ blok.headline }}
          </span>
          <span v-else>{{ name }}</span>
        </h1>
        <p
          class="mt-2 text-lg font-medium text-neutral-300 drop-shadow-lg sm:text-xl"
        >
          <span v-if="type !== 'Booking Confirmation'">
            {{ blok.lead }}
          </span>
          <span v-else>
            Hey there! We cannot wait to welcome you to {{ name }}. Here you can
            find all the information you need to make your Live For Today
            adventure a success.
          </span>
        </p>
      </div>
      <div
        v-if="shouldShowVideo"
        class="relative col-span-1 flex items-center justify-center overflow-visible lg:col-span-2"
      >
        <MarketingContentVideo class="w-full" :blok="videoBlok" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type {
  PageStoryblok,
  MultilinkStoryblok,
} from '~/types/component-types-sb';
import { computed, onMounted } from 'vue';

interface Props {
  blok: {
    headline?: string;
    lead?: string;
    hero_link?: PageStoryblok['hero_link'];
    youtube_url?: Exclude<
      MultilinkStoryblok,
      { linktype?: 'email' } | { linktype?: 'asset' }
    >;
  };
  type?: string;
  name?: string;
}

const props = defineProps<Props>();

// Use useState for shared state between server and client
const isClient = useState('hero-video-is-client', () => false);

// Add hydration guard for client-side initialization
onMounted(() => {
  if (import.meta.client) {
    isClient.value = true;
  }
});

// Add type assertion for MarketingContentVideo
const videoBlok = computed(() => ({
  youtube_url: props.blok.youtube_url as Exclude<
    MultilinkStoryblok,
    { linktype?: 'email' } | { linktype?: 'asset' }
  >,
}));

// Add computed property for conditional rendering
const shouldShowVideo = computed(() => {
  return isClient.value && props.blok.youtube_url?.url;
});
</script>
